// auto add label to checkboxes
function customforms_checkbox() {
	const checkboxes = document.querySelectorAll('input[type="checkbox"]');
	checkboxes.forEach(checkbox => {
        const label = document.createElement('label');
        checkbox.parentNode.insertBefore(label, checkbox.nextSibling);
	})
}

document.addEventListener('DOMContentLoaded', () => {
	customforms_checkbox();
})

// var mobile = require('is-mobile');

function dropDownImage(image, el) {
	const optionImageURL = image.getAttribute('data-image');
	if(optionImageURL) {
		// console.log(optionImageURL);
		// Create <img> element for the image
		const optionImage = document.createElement('img');
		optionImage.src = optionImageURL;
		optionImage.alt = image.textContent; // Set alt text to option text
		el.appendChild(optionImage);
		// console.log(optionImageURL);
	}
}

import { setCookie } from './functions.js';
import { getCookie } from './functions.js';
import { getLanguageCookie } from './functions.js';
import { setLanguageCookie } from './functions.js';

function customforms_select() {
	// if (!isMobile()) {
		const selects = document.querySelectorAll('select');
		selects.forEach(select => {

			// create custom dropdown wrapper
			const dropdownParent = document.createElement('div');
			dropdownParent.className = 'custom-dropdown ' + select.className;

			// get data from select field
			const options = select.querySelectorAll('option');

			// custom dropdown text
			const customDropdownText = document.createElement('div');
			customDropdownText.className = 'custom-dropdown-text';
			dropdownParent.appendChild(customDropdownText);
			customDropdownText.textContent = options[0].textContent;

			// wrap the select inside a custom dropdown
			select.parentNode.insertBefore(dropdownParent, select);
			dropdownParent.appendChild(select);

			// custom dropdown
			const dropdown = document.createElement('ul');
			dropdown.className = 'dropdown';
			dropdownParent.append(dropdown);

			// custom dropdown arrow
			const customArrow = document.createElement('div');
			customArrow.className = 'custom-arrow';
			customArrow.innerHTML = '<svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.36603 10.5C6.98112 11.1667 6.01887 11.1667 5.63397 10.5L0.870835 2.25C0.485935 1.58333 0.967061 0.750001 1.73686 0.750001L11.2631 0.750002C12.0329 0.750002 12.5141 1.58334 12.1292 2.25L7.36603 10.5Z" fill="white"/></svg>';
			dropdownParent.appendChild(customArrow);

			options.forEach((option, index) => {

				// create <li> list
				const listItem = document.createElement('li');
				dropdown.appendChild(listItem);

				// set values of each item list from <option>
				listItem.textContent = option.value;
				listItem.setAttribute('data-value', option.value);

				// Add image to custom dropdown <li>, data url grabbed from data-image=""
				dropDownImage(option, listItem);

				listItem.addEventListener('click', () => {
					const value = listItem.getAttribute('data-value');
					customDropdownText.textContent = listItem.textContent; // change custom-dropdown-text value

					// Update the selected option value of the associated <select>
					select.value = value;
					select.dispatchEvent(new Event('change')); // Dispatch the change event

					// add selected class to parent when clicking listitem but the first placeholder
					if (index > 0) {
						dropdownParent.classList.add('selected');
					} else {
						dropdownParent.classList.remove('selected');
					}
				});

			})

			dropdownParent.addEventListener('click', () => {
				dropdownParent.classList.toggle('active');
			});

		})
	// }
}

// Global click event listener to close dropdowns when clicking outside
document.addEventListener('click', (event) => {
    const dropdowns = document.querySelectorAll('.custom-dropdown');
    dropdowns.forEach(dropdown => {
        if (!dropdown.contains(event.target)) {
            dropdown.classList.remove('active');
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
	customforms_select();
})


document.addEventListener('wpcf7mailsent', function (event) {
	var formId = event.detail.contactFormId;

	// Replace 123 with the actual form ID you want to target
	if (formId === '1db1378') {
		// Code to execute upon successful form submission
		// alert('Form submitted successfully!');
		// You can replace the alert with your custom code.
	}
});

const wpcf7responses = document.querySelectorAll('.wpcf7-response-output');
wpcf7responses.forEach(wpcf7response => {
	wpcf7response.addEventListener('click', (event) => {

		wpcf7response.innerHTML = '';
		// Remove a class from a div a couple of parents above the clicked element
		const target = event.target;
		const parent = target.closest('.wpcf7-form');
		if (parent) {
			parent.classList.remove('invalid');
			parent.classList.remove('sent');
			parent.classList.remove('failed');
		}

	})
});
// document.addEventListener('click', (event) => {

// 	const forms = document.querySelectorAll('.wpcf7-form');
//     wpcf7responses.forEach(wpcf7response => {
// 		wpcf7response.innerHTML = '';
//     });

//     // Remove a class from a div a couple of parents above the clicked element
//     const target = event.target;
//     const parentDiv = target.closest('.wpcf7-form');
//     if (parent) {
//         parent.classList.remove('invalid');
//     }

// })

// document.addEventListener('DOMContentLoaded', function () {
//     var forms = document.querySelectorAll('form.wpcf7-form');
//     forms.forEach(function (form) {
//         form.addEventListener('wpcf7submit', function (event) {
// 			console.log('dog');
//             var inputsWithErrors = form.querySelectorAll('.wpcf7-not-valid');

//             inputsWithErrors.forEach(function (input) {
//                 input.classList.add('validation-error');
//             });
//         });
//     });
// });
